import React, { useState } from 'react';
import { Button, message, Modal, Typography } from 'antd';
import Popup from '@root/core/components/Popup';
import { useHistory, useParams } from 'react-router';
import busksellerdetail from '../services/busksellerdetail';

interface Props {
  type: string;
  state: string | undefined;
}
const ButtonSubmit = ({ type, state }: Props) => {

  const [isOpen, setIsOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const history = useHistory();
  const { id } = useParams<{ id: string }>();

  const buskCheckApprove = async (id: string) => {
    try{
      if (state === '가입신청자') {
        setConfirmLoading(true);
        const buskCheckApprove = await busksellerdetail.ApproveSellerSignup(id);
        setConfirmLoading(false);
        history.push('/admin/busk/sellers');
      } else {
        setConfirmLoading(true);
        const buskCheckApprove = await busksellerdetail.ApproveSellerAmendment(
          id
        );
        setConfirmLoading(false);
        history.push('/admin/busk/sellers');
      }
    } catch(error:any){
      setConfirmLoading(false);
      message.error(error?.response?.data?.message[0]);    
    }
  };

  const buskCheckReject = async (id: string) => {
    try{
      if (state === '가입신청자') {
        setConfirmLoading(true);
        const buskCheckReject = await busksellerdetail.RejectSellerSignup(id);
        setConfirmLoading(false);
        history.push('/admin/busk/sellers');
      } else {
        setConfirmLoading(true);
        const buskCheckReject = await busksellerdetail.RejectSellerAmendment(id);
        setConfirmLoading(false);
        history.push('/admin/busk/sellers');
      }
    }catch(error:any){
      setConfirmLoading(false);
      message.error(error?.response?.data?.message[0]);    
    }
  };

  return (
    <div>
      <Button
        type="primary"
        style={{
          padding: '.5rem 2.5rem',
          height: 'auto',
          border: 'none',
          borderRadius: '7.25px',
          backgroundColor: type === '거절' ? '#ABABAB' : '#2B2C51',
          display:
            state === '일반회원' || state === '거절' ? 'none' : 'inline-block'
        }}
        onClick={() => setIsOpen(true)}
      >
        {type === '거절' ? '거절' : '승인'}
      </Button>
      {type === '거절' ? (
        <Modal
          centered
          visible={isOpen}
          onOk={() => buskCheckReject(id)}
          onCancel={() => setIsOpen(false)}
          confirmLoading={confirmLoading}
          okText="확인"
          cancelText="취소"
          className="busk-modal"
        >
          <Typography.Title level={2}>거절하시겠습니까?</Typography.Title>
          <Typography.Text>
            {state === '가입신청자'
              ? '확인을 클릭하면 해당 가입 신청이 거절됩니다.'
              : '확인을 클릭하면 해당 셀러 정보 수정이 거절됩니다.'}
          </Typography.Text>
        </Modal>
      ) : (
        <Modal
          centered
          visible={isOpen}
          onOk={() => buskCheckApprove(id)}
          onCancel={() => setIsOpen(false)}
          confirmLoading={confirmLoading}
          okText="확인"
          cancelText="취소"
          className="busk-modal"
        >
          <Typography.Title level={2}>승인하시겠습니까?</Typography.Title>
          <Typography.Text>
            확인을 클릭하면 해당 셀러에게 승인 메일을 전송합니다.
          </Typography.Text>
        </Modal>
      )}
    </div>
  );
};

export default ButtonSubmit;
